import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { avantorAnimations } from '@core/animations/animations';
import { NewsService } from '@core/services/news/news-api';
import { News } from '@shared/models';
import { Subject, Subscription, takeUntil } from 'rxjs';
const datepipe: DatePipe = new DatePipe('en-US');
import moment from 'moment';
import 'moment-timezone';
import { Store } from '@ngrx/store';
import { AppState } from '@core/store/reducers/common.reducer';
import { getStockroomOrgDetails } from '@core/store/selectors/common.selectors';
import { ActivatedRoute , RouterModule} from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';
@Component({
  selector: 'app-news-panel',
  templateUrl: './news-panel.html',
  styleUrls: ['./news-panel.scss'],
  animations: [avantorAnimations],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule, RouterModule],
})
export class NewsPanelComponent implements OnInit {
  newsList: News[] = []
  isLoading: boolean = true;
  currentOrganization: any;
  organizationTimeZone: string = "";
  organizationDateTimeFormat: string = "";
  stokroomOrgSubscription!: Subscription;


  @Input() newsData: any
  private destroy$: Subject<void> = new Subject();

  constructor(
    private newsService: NewsService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initStore();
    this.getUnReadMessages();
    sessionStorage.setItem('isNewsPanelBlocked', 'true');

  }

  ngOnChanges(changes: SimpleChanges) {
    this.getUnReadMessages();
  }

  initStore() {
    this.stokroomOrgSubscription = this.store.select(getStockroomOrgDetails).subscribe((res: any) => {
      this.currentOrganization = res?.organization;
      this.organizationTimeZone = res?.organization?.timeZone;

      let organizationTimeFormatString = this.currentOrganization.timeFormat == '_24HOURS' ? 'HH:mm:ss' : 'hh:mm:ss A';
      let organizationDateFormatString: string = '';

      if (this.currentOrganization.dateFormat == 'YYYY_MM_DD') organizationDateFormatString = 'YYYY-MM-DD';
      else if (this.currentOrganization.dateFormat == 'DD_MM_YYYY') organizationDateFormatString = 'DD-MM-YYYY';
      else organizationDateFormatString = 'MM-DD-YYYY';

      this.organizationDateTimeFormat = `${organizationDateFormatString} ${organizationTimeFormatString}`;
    });
  }

  getUnReadMessages() {
    if (this.newsData) {
      this.newsList = [];
      let newsList = this.newsData;

      newsList.forEach((element: any) => {
        if (element.statusString == 'unread') {
          if (this.newsList.length < 10) this.newsList.push(element);
        }
      });
      this.isLoading = false;
    } else {
      this.newsService.getNew()
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          if (result?.data) {
            this.newsList = [];
            let newsList = result.data;
            newsList = result.data.map((news: any) => {
              if (news.startDate) {
                const startDate = news.startDate.replace('T', " ");
                news.startDate = moment.tz(startDate, 'America/New_York').tz(this.organizationTimeZone).format(this.organizationDateTimeFormat);
              }
              return news
            })
            newsList.forEach((element: any) => {
              if (element.statusString == 'unread') {
                if (this.newsList.length < 10) this.newsList.push(element);
              }
            });

            this.isLoading = false;
          }
        });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**---------------------------------------------
  * @CLOSE_PANEL
  * Close panel event
  */
  @Input() openPanel: boolean = false;
  @Output() closePanel = new EventEmitter<void>();

  intializeContents() {
    this.newsService.getNews(0, -1, 'createdDate:desc', '');
  }

  setDate(unixVal: number) {
    return datepipe.transform(new Date(unixVal), 'MMMM d, y');
  }

  close() {
    this.closePanel.emit();
  }

  setNewsForRead(news: any) {
    this.newsService.setNewsForRead(news);
    this.close();
  }

}
